var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';
import { getAllNotes, getAnnotationCategories, createNewNote, deleteNote, } from '@/clients/applets';
let Notes = class Notes extends Vue {
    constructor() {
        super(...arguments);
        this.screen = 'list';
        this.notes = [];
        this.availableCategories = [];
        this.loading = false;
        this.showDeleteDialog = false;
        this.noteToDelete = null;
        this.isReadOnly = false;
        this.noteData = {
            note: '',
            business_potential: '',
            categories: [],
            reminder: '',
        };
    }
    async mounted() {
        await this.fetchNotes();
        await this.fetchCategories();
    }
    async fetchNotes() {
        this.loading = true;
        try {
            const response = await getAllNotes(this.companyId);
            this.notes = (response && response.data && response.data.value) || [];
        }
        catch (error) {
            console.error('Error fetching notes:', error);
        }
        finally {
            this.loading = false;
        }
    }
    async fetchCategories() {
        try {
            const response = await getAnnotationCategories();
            if (response &&
                response.status === 200 &&
                response.data &&
                response.data.keywords) {
                this.availableCategories = response.data.keywords;
            }
        }
        catch (error) {
            console.error('Error fetching categories:', error);
        }
    }
    formatReminder(reminder) {
        if (!reminder)
            return '';
        return moment(reminder, 'YYYY-MM-DD').format('DD/MM/YYYY');
    }
    openForm() {
        this.resetNoteData();
        this.isReadOnly = false;
        this.screen = 'form';
    }
    resetNoteData() {
        this.noteData = {
            note: '',
            business_potential: '',
            categories: [],
            reminder: moment().format('DD/MM/YYYY'),
        };
    }
    viewNote(note) {
        this.noteData = {
            note: note.note,
            business_potential: note.business_potential
                ? `R$${note.business_potential}`
                : '',
            categories: note.categories || [],
            reminder: note.reminder
                ? moment(note.reminder, 'YYYY-MM-DD').format('DD/MM/YYYY')
                : '',
        };
        this.isReadOnly = true;
        this.screen = 'form';
    }
    cancelForm() {
        this.screen = 'list';
    }
    addNewCategory(value, done) {
        if (value && !this.availableCategories.includes(value)) {
            this.availableCategories.push(value);
        }
        done(value, 'toggle');
    }
    async saveNote() {
        // @ts-ignore
        const valid = await this.$refs.noteForm.validate();
        if (!valid)
            return;
        this.loading = true;
        const data = {
            company_id: this.companyId,
            note: this.noteData.note,
            reminder: this.noteData.reminder,
            categories: this.noteData.categories,
            business_potential: this.noteData.business_potential
                .replace('R$', '')
                .trim(),
        };
        try {
            await createNewNote(data);
            await this.fetchNotes();
            this.screen = 'list';
        }
        catch (error) {
            console.error('Error saving note:', error);
        }
        finally {
            this.loading = false;
        }
    }
    confirmDelete(note) {
        this.noteToDelete = note;
        this.showDeleteDialog = true;
    }
    async deleteNote() {
        if (!this.noteToDelete)
            return;
        this.loading = true;
        try {
            const noteId = this.noteToDelete._id.$oid || this.noteToDelete._id;
            await deleteNote(noteId);
            await this.fetchNotes();
        }
        catch (error) {
            console.error('Error deleting note:', error);
        }
        finally {
            this.loading = false;
            this.noteToDelete = null;
            this.showDeleteDialog = false;
        }
    }
};
__decorate([
    Prop({ default: '' })
], Notes.prototype, "companyId", void 0);
__decorate([
    Prop({ default: () => ({}) })
], Notes.prototype, "company", void 0);
Notes = __decorate([
    Component({
        name: 'Notes',
    })
], Notes);
export default Notes;
